import { IonButton, IonCol, IonContent, IonGrid, IonImg, IonPage, IonPopover, IonRow, IonText, IonIcon, useIonViewWillLeave } from '@ionic/react';
import { openOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import Footer from '../../components/Footer';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import { fetchOrgBySlug } from '../../services/org_service';
import { fetchCatsIn } from '../../services/taxononmies';
import { fetchOrgRelatedFundraisers } from '../../services/fundraise_service';
import CampaignCard from '../../components/CampaignCard';
import { userLink } from '../../utlities/userLink';



interface OrgdetailProps {
    user: User | any
}

const Orgdetail: React.FC<OrgdetailProps> = ({ user }) => {

    const svgUrl = `${import.meta.env.BASE_URL}images/svg/`;

    const history = useHistory()

    const siteText = translation();

    const lan = siteText.lan.replace("/", "")

    const pathName = useLocation().pathname;
    //__
    const isAccountPage = () => {
        if (pathName.indexOf('account') < 0) return false;
        return true
    }

    const navigate = (e: string) => {

        if (isAccountPage()) {
            history.push(`/${lan}/account/fundraisers/${e}`);
        } else {
            history.push(`/${lan}/fundraisers/${e}`)
        }
    }
    const loginFirst = () => {
        history.push({ pathname: `/${lan}/signin`, state: { destination: `/account/donate_direct_to_org_V2?id=${organization.id}` } })
    }

    const [organization, setOrganization] = useState<any>(null);
    //__
    const [organizationCategories, setOrganizationCategories] = useState<any>(null)// revise

    const [orgFundraisers, setOrgFundraisers] = useState<any>(null)

    const { id } = useParams<{ id: string }>();


    // fetch data
    useEffect(() => {
        let mounted = true;
        //getOrganisations().then();

        fetchOrgBySlug(id).then(
            ({ message }) => {
                if (message) {
                    setOrganization(message[0]);
                    fetchOrgRelatedFundraisers(message[0].acf._rel_org.ID).then(m => setOrgFundraisers(m.message))
                    if (message[0].categories) {
                        fetchCatsIn(message[0].categories).then(
                            ({ message: more }) => {
                                if (more) {
                                    setOrganizationCategories(
                                        more
                                            .filter((cat: any) => cat.parent !== 0)
                                            .map((cat: any) => cat.acf[lan]).filter((name: any) => name !== "")
                                    )

                                }
                            }
                        )
                    }
                }
            }
        )
        return () => {
            mounted = false;
            setOrganization(null)
        };
    }, [id])


    const goToDonatePage = () => {
        history.push(`/${lan}/${userLink(user)}donate_direct_to_org_V2?id=${organization.id}`)

    }

    const descriptionHtml = (html: string) => {
        return { __html: html }
    }



    return (
        <IonPage className='pageContent '>
            <IonContent>
                <IonGrid className='article-body'>
                    {
                        organization &&
                        <IonRow>
                            <IonCol offsetSm='1' sizeSm='10' className='article-header white_bg' style={{ padding: '0', borderRadius: '30px 30px 0px 0px' }}>
                                <IonRow className='sw_sp_xs organizationDetailHeader ion-margin-top'>
                                    <IonCol className='wrapper '>
                                        <IonImg className='' src={organization.acf._logo}></IonImg>
                                        <IonText color={'dark'}>
                                            <h1 className='h2'>{organization.acf._nom}</h1>
                                        </IonText>
                                    </IonCol>
                                </IonRow>
                                {
                                    organization.acf.image &&
                                    <IonRow  >
                                        <IonCol style={{ padding: '0' }} className=''>
                                            <IonImg src={organization.acf.image}></IonImg>
                                        </IonCol>
                                    </IonRow>
                                }
                                <IonRow className='sw_sp_sm'>
                                    <IonCol sizeXs='12' className='ion-hide-md-up'>
                                        {/*Dontate with credits*/}
                                        {organization.acf.external_donations &&
                                            <>
                                                {organization.acf._external_donation_url && <IonButton size="small" className='sw_mb_sm' mode='ios' ><IonIcon slot='start' color='light' icon='openOutline'></IonIcon><IonText color='light'> {siteText.charityDetailPrimary} </IonText>    </IonButton>}
                                            </>}
                                        {/*donate with credit */}
                                        {!organization.acf.external_donations && <IonButton size='small' onClick={_ => goToDonatePage()} mode='ios' ><IonIcon slot='start' size='small' color='light' src={`${svgUrl}${'fundraise_2.svg'}`}></IonIcon><IonText color='light'>{siteText.charityDetailPrimary}</IonText></IonButton>}


                                        {/*got to website */}
                                        {organization.acf._site_url && <IonButton size='small' fill='clear' href={organization.acf._site_url} target='_blank' rel="noopener"><IonIcon slot='start' size='small' icon={openOutline}></IonIcon>{`${organization.acf._site_url.slice(8, 28)}`}</IonButton>}
                                    </IonCol>

                                    <IonCol sizeXs="12" sizeMd='8' className='ion-padding'>
                                        <IonText color={'dark'}>

                                            <div dangerouslySetInnerHTML={descriptionHtml(organization.acf._description)}></div>
                                        </IonText>
                                        <IonRow>
                                            <IonCol sizeXs='12'>
                                                {/*Dontate with credits*/}
                                                {organization.acf.external_donations &&
                                                    <>
                                                        {organization.acf._external_donation_url && <IonButton size="small" className='sw_mb_sm' mode='ios' ><IonIcon slot='start' color='light' icon='openOutline'></IonIcon><IonText color='light'> {siteText.charityDetailPrimary} </IonText>    </IonButton>}
                                                    </>}
                                                {/*donate with credit */}
                                                {!organization.acf.external_donations && <IonButton size='small' onClick={_ => goToDonatePage()} mode='ios' ><IonIcon slot='start' size='small' color='light' src={`${svgUrl}${'fundraise_2.svg'}`}></IonIcon><IonText color='light'>{siteText.charityDetailPrimary}</IonText></IonButton>}


                                                {/*got to website */}
                                                {organization.acf._site_url && <IonButton size='small' fill='clear' href={organization.acf._site_url} target='_blank' rel="noopener"><IonIcon slot='start' size='small' icon={openOutline}></IonIcon>{`${organization.acf._site_url.slice(8, 28)}`}</IonButton>}
                                            </IonCol>
                                        </IonRow>
                                    </IonCol>
                                    <IonCol className='ion-hide-md-down ion-padding-end ion-padding-start' sizeSm='4' >
                                        {(!orgFundraisers || orgFundraisers.length < 1) && <div>
                                            {/*Dontate with credits*/}
                                            {organization.acf._external_donations &&
                                                <>
                                                    {organization.acf._external_donation_url && <IonButton className='sw_mb_sm' mode='ios' expand='block'><IonIcon slot='start' color='light' icon='openOutline'></IonIcon><IonText color='light'> {siteText.charityDetailPrimary} </IonText>    </IonButton>}
                                                </>}
                                            {/*donate with credit */}
                                            {!organization.acf._external_donations && <IonButton onClick={_ => goToDonatePage()} className='sw_mb_sm' mode='ios' expand='block'><IonIcon slot='start' size='small' color='light' src={`${svgUrl}${'fundraise_2.svg'}`}></IonIcon><IonText color='light'>{siteText.charityDetailPrimary}</IonText></IonButton>}


                                            {/*Donate through external platform */}
                                            <div className=''>
                                                {organization.acf._site_url && <IonButton fill='clear' href={organization.acf._site_url} target='_blank' rel="noopener"><IonIcon slot='start' size='small' icon={openOutline}></IonIcon>{`${organization.acf._site_url.slice(8, 28)}`}</IonButton>}
                                            </div>
                                            {/**Charity ongoing fundraisers */}
                                        </div>}
                                        {(orgFundraisers && orgFundraisers.length > 0) &&
                                            <div>
                                                <div style={{ display: "flex",flexWrap:"wrap" }}>
                                                    {/**Charity ongoing fundraisers */}
                                                    {/*Dontate with credits*/}
                                                    {organization.acf._external_donations &&
                                                        <>
                                                            {organization.acf._external_donation_url && <IonButton size='small' fill='outline' mode='ios'><IonIcon color='light' icon='openOutline'></IonIcon><IonText color='light'> {siteText.charityDetailPrimary} </IonText>    </IonButton>}
                                                        </>}
                                                    {/*donate with credit */}
                                                    {!organization.acf._external_donations && <IonButton onClick={(e: any) => goToDonatePage()} mode='ios'><IonIcon size='small' color='light' src={`${svgUrl}${'fundraise_2.svg'}`}></IonIcon><IonText color='light'>{siteText.charityDetailPrimary}</IonText></IonButton>}
                                                    <div className=''>
                                                        {organization.acf._site_url && <IonButton mode='ios' fill='outline' href={organization.acf._site_url} target='_blank' rel="noopener"><IonIcon icon={openOutline}></IonIcon>{`${organization.acf._site_url.slice(8, 28)}`}</IonButton>}
                                                    </div>
                                                </div>
                                                {/*Donate through external platform */}
                                                <h4 className='ion-padding-start ion-padding-end' style={{ marginBottom: '-20px' }}>{siteText.charityDetailPageSidebarLabel}</h4>
                                                {orgFundraisers.map((m: any, key: any) =>
                                                    <CampaignCard key={key} title={m.title} user={user} imageUrl={m.acf.image} description={m.acf.reason} id={m.id} navigate={navigate} ></CampaignCard>
                                                )}
                                            </div>


                                        }
                                    </IonCol>

                                    {
                                        (orgFundraisers && orgFundraisers.length > 0) &&
                                        <IonCol className='ion-hide-md-up'>

                                            <div>
                                                <h4 className='ion-padding-start ion-padding-end' style={{ marginBottom: '-20px' }}>{siteText.charityDetailPageSidebarLabel}</h4>
                                                {orgFundraisers.map((m: any, key: any) =>
                                                    <CampaignCard key={key} title={m.title} user={user} imageUrl={m.acf.image} description={m.acf.reason} id={m.id} navigate={navigate} ></CampaignCard>
                                                )}
                                            </div>
                                        </IonCol>
                                    }
                                </IonRow>
                            </IonCol>
                        </IonRow>

                    }
                </IonGrid>
                <Footer></Footer>
            </IonContent>
        </IonPage>
    );
};

export default Orgdetail;
